import React, {Component} from 'react';
import TermsAndPrivacyPolicyComponent from "../../termsandprivacypolicy/components/TermsAndPrivacyPolicyComponent";
import MenuFooterComponent from "../../menufooter/components/MenuFooterComponent";
import { withTranslation } from 'react-i18next';

import "../style/FooterStyle.scss"

class FooterComponent extends Component {
    constructor(props) {
        super(props);
        this.firstMenu = [
            // {title: "Register", "isAnchor": true, link: "/#register"},
            {title: this.props.t("Our Brands"), "isAnchor": true, link: "/#ourbrands"},
            {title: this.props.t("navbar_item_2"), "isAnchor": true, link: "/#ourplatform"},
            {title: this.props.t("Our Retailers"), "isAnchor": true, link: "/#ourretailers"},
            {title: this.props.t("Who We Are"), link: "/whoweare"},
            {title: this.props.t("Register"), "isAnchor": true, link: "/#register"}
        ];
        if (this.props.t('lang') === 'pt_BR') {
            this.firstMenu.splice(2,1);
        }
        this.secondMenu = [
            {title: "E-mail", email: 'hello@blancfashion.com', isEmail: true},
            {title: "Facebook", blank: true, link: "https://www.facebook.com/blancfashionbr/"},
            // {title: "Twitter", blank: true, link: "/"},
            {title: "Instagram", blank: true, link: "https://www.instagram.com/blancfashionbr/"},
        ];
        this.lastMenu = [
            {title: this.props.t("Who We Are"), link: "/whoweare"},
            {title: this.props.t("Our Team"), link: "/whoweare#ourteam"}
        ];

        this.state = {
            TermsAndConditions: "",
            privacyPolicy: ""
        }
    };

    render() {
        return (
            <footer>
                <div className="centerComponent contentFooter">
                    <div className="logo">
                        <img src={`${process.env.PUBLIC_URL}/images/logoFooter.png`} alt="logo"/>
                    </div>
                    <TermsAndPrivacyPolicyComponent />
                    <div className="divisor" />

                    { !window.localStorage.getItem("user") &&
                    <div className="menuFooter">
                        <MenuFooterComponent header={this.props.t('Find out more')} navItens={this.firstMenu}/>
                        <MenuFooterComponent header={this.props.t('Our Contacts')} navItens={this.secondMenu}/>
                        <div id="MenuFooterComponent"></div>
                    </div>
                    }
                    <div className="copyright">copyright blanc @ 2019 - bunker.vc</div>
                </div>
            </footer>
        );
    }
};

export default withTranslation()(FooterComponent);
